module.exports = __webpack_public_path__ + "assets/ic_arrow_right3.852adadf.svg";